import React, { useState } from 'react';

// import component
import MessengerList from '../../pages/messenger/MessengerList';
import logomain from "../../image/logo_main.png";

// import icons
import { IoMdCloseCircle } from 'react-icons/io';
import { FaMinus } from "react-icons/fa";
import { MdOutlineFullscreen, MdFullscreenExit } from 'react-icons/md';

export default function DailogChatMsg({ setIsChatMsg }) {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const onFullscreen = () => {
        const element = document.querySelector('.card-chat-msg');
        if (!isFullscreen) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) { // Firefox
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) { // Chrome, Safari and Opera
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) { // IE/Edge
                element.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { // IE/Edge
                document.msExitFullscreen();
            }
        }
        setIsFullscreen(!isFullscreen);
    };

    return (
        <div className='card-chat-msg'>

            {/* chat header */}
            <div className='chat-header'>
                <div className='profile-brand'>
                    <img src={logomain} alt="logo" />
                    <p>Chats</p>
                </div>

                <div className='action-chat'>
                    <div onClick={onFullscreen}>
                        {isFullscreen ? <MdFullscreenExit /> : <MdOutlineFullscreen />}
                    </div>
                    <div>
                        <FaMinus />
                    </div>
                    <div onClick={() => setIsChatMsg(false)}>
                        <IoMdCloseCircle />
                    </div>
                </div>
            </div>

            {/* messenger list */}
            <MessengerList />
        </div>
    );
}
